export const genderOptions = [
  {
    name: "Male",
    value: "Male",
  },
  {
    name: "Female",
    value: "Female",
  },
  {
    name: "Others",
    value: "Others",
  },
];

export const noticeRequiredOptions = [
  {
    name: "1 Week",
    value: "1 Week",
  },
  {
    name: "2 Week",
    value: "2 Week",
  },
  {
    name: "3 Week",
    value: "3 Week",
  },
  {
    name: "1 Month",
    value: "1 Month",
  },
  {
    name: "2 Months",
    value: "2 Months",
  },
  {
    name: "3 Months",
    value: "3 Months",
  },
  {
    name: "6 Months",
    value: "6 Months",
  },
  {
    name: "Unknown",
    value: "Unknown",
  },
];

export const workPermitOptions = [
  {
    name: "Yes",
    value: true,
  },
  {
    name: "No",
    value: false,
  },
];

export const salaryrangeOptions = [
  {
    name: "0-15000",
    value: "0-15000",
  },
  {
    name: "15001-17500",
    value: "15001-17500",
  },
  {
    name: "17501-20000",
    value: "17501-20000",
  },
  {
    name: "20001-22500",
    value: "20001-22500",
  },
  {
    name: "22501-25000",
    value: "22501-25000",
  },
  {
    name: "25001-27500",
    value: "25001-27500",
  },
  {
    name: "27501-30000",
    value: "27501-30000",
  },
  {
    name: "30001-35000",
    value: "30001-35000",
  },
  {
    name: "35001-40000",
    value: "35001-40000",
  },
  {
    name: "40001-45000",
    value: "40001-45000",
  },
  {
    name: "45001-50000",
    value: "45001-50000",
  },
  {
    name: "50001-55000",
    value: "50001-55000",
  },
  {
    name: "55001-60000",
    value: "55001-60000",
  },
  {
    name: "60000-75000",
    value: "60000-75000",
  },
  {
    name: "75001-100000",
    value: "75001-100000",
  },
  {
    name: "100001-120000",
    value: "100001-120000",
  },
  {
    name: "120001-150000",
    value: "120001-150000",
  },
  {
    name: "150001-200000",
    value: "150001-200000",
  },
  {
    name: "200001-250000",
    value: "200001-250000",
  },
];

export const hourlyrateOptions = [
  {
    name: "5",
    value: "5",
  },
  {
    name: "10",
    value: "10",
  },
  {
    name: "15",
    value: "15",
  },
  {
    name: "20",
    value: "20",
  },
  {
    name: "25",
    value: "25",
  },
  {
    name: "30",
    value: "30",
  },
  {
    name: "35",
    value: "35",
  },
  {
    name: "40",
    value: "40",
  },
  {
    name: "45",
    value: "45",
  },
  {
    name: "50",
    value: "50",
  },
];

export const tempOrPermOptions = [
  {
    name: "Permamanent",
    value: "Permamanent",
  },
  {
    name: "Contract",
    value: "Contract",
  },
  {
    name: "temp or perm",
    value: "temp or perm",
  },
  {
    name: "temp or contract",
    value: "temp or contract",
  },
];

export const iStatusOptions = [
  {
    name: "prescreen",
    value: "prescreen",
  },
  {
    name: "prescreen cv submitted",
    value: "prescreen cv submitted",
  },
  {
    name: "interview",
    value: "interview",
  },
  {
    name: "interview 2",
    value: "interview 2",
  },
  {
    name: "interview 3",
    value: "interview 3",
  },
  {
    name: "offer",
    value: "offer",
  },
  {
    name: "offer accepted",
    value: "offer accepted",
  },
  {
    name: "started",
    value: "started",
  },
];

export const jobRatingOptions = [
  {
    name: "1",
    value: "1",
  },
  {
    name: "2",
    value: "2",
  },
  {
    name: "3",
    value: "3",
  },
  {
    name: "4",
    value: "4",
  },
  {
    name: "5",
    value: "5",
  },
];

export const sourceOptions = [
  {
    name: "Facebook",
    value: "Facebook",
  },
  {
    name: "Friends",
    value: "Friends",
  },
  {
    name: "Megazines",
    value: "Megazines",
  },
  {
    name: "Others",
    value: "Others",
  },
];

export const RBACOptions = [
  { name: "Admin", value: "admin" },
  { name: "Manager", value: "manager" },
  { name: "Registered Manager", value: "registered manager" },
  { name: "Nominated Individual", value: "nominated individual" },
  { name: "Care Manager", value: "care manager" },
  { name: "Care Coordinator", value: "care coordinator" },
  { name: "Care Supervisor", value: "care supervisor" },
  { name: "Senior Carer", value: "senior carer" },
  { name: "Care Worker", value: "care worker" },
  { name: "Support Worker", value: "support worker" },
  { name: "Nurse", value: "nurse" },
  { name: "Trainer", value: "trainer" },
  { name: "Rapid Responder", value: "rapid responder" },
];

export const jobTitleOptions = [
  { name: "ADMINISTRATIVE ASSISTANT", value: "ADMINISTRATIVE ASSISTANT" },
  { name: "Accounts", value: "Accounts" },
  { name: "Accounts Manager", value: "Accounts Manager" },
  { name: "Administrator", value: "Administrator" },
  { name: "Allocator Coordinator", value: "Allocator Coordinator" },
  { name: "Assistant Accountant", value: "Assistant Accountant" },
  { name: "CARE WORKER", value: "CARE WORKER" },
  { name: "Care Assistance", value: "Care Assistance" },
  { name: "Care Home Manager", value: "Care Home Manager" },
  { name: "Carer", value: "Carer" },
  { name: "Drivers", value: "Drivers" },
  { name: "Feild Support Worker", value: "Feild Support Worker" },
  {
    name: "Field Quality Assurance Officer",
    value: "Field Quality Assurance Officer",
  },
  { name: "HEALTH CARE ASSISTANT", value: "HEALTH CARE ASSISTANT" },
  { name: "Human Resource", value: "Human Resource" },
  { name: "Managing Director", value: "Managing Director" },
  { name: "Nurse", value: "Nurse" },
  { name: "Office Manager", value: "Office Manager" },
];

export const workAreaOptions = [
  { name: "Care", value: "Care" },
  { name: "Domestic", value: "Domestic" },
  { name: "Maintenance", value: "Maintenance" },
  { name: "Administration", value: "Administration" },
];
